import { createSlice } from '@reduxjs/toolkit';
import { getNotifications } from './asyncThunks';

const panelInitialState = {
  visibility: false,
};

const notificationsInitialState = {
  panel: panelInitialState,
  notifications: [],
  isLoadingData: false,
  errors: [],
};

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState: notificationsInitialState,
  reducers: {
    setVisibility: (state, { payload }) => {
      const { visibility } = payload;
      return { ...state, panel: { ...state.panel, visibility } };
    },
  },
  extraReducers: {
    [getNotifications.fulfilled]: (state, { payload }) => {
      const { notifications } = payload;
      return {
        ...state,
        notifications,
        isLoadingData: false,
        errors: [],
      };
    },
    [getNotifications.pending]: (state) => {
      return {
        ...state,
        isLoadingData: true,
        errors: [],
      };
    },
    [getNotifications.rejected]: (state, { payload }) => {
      const { errors } = payload;
      return {
        ...state,
        isLoadingData: false,
        errors,
      };
    },
  },
});

export default notificationsSlice.reducer;
export const { setVisibility } = notificationsSlice.actions;
